/* Update collection results without reloading storefront scripts or banners. */
(() => {
  const section = document.getElementById('shopify-section-bingo-template-collections');
  if (!section || !window.fetch || !window.DOMParser) return;
  document.documentElement.dataset.peteFastCollection = 'true';
  const sectionId = section.id.replace('shopify-section-', '');
  const cache = new Map();
  let sequence = 0;
  let busy = false;
  const status = document.createElement('p');
  status.setAttribute('role', 'status');
  status.setAttribute('aria-live', 'polite');
  status.className = 'pete-collection-status';
  status.style.cssText = 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0';
  section.before(status);

  function cleanURL(value) {
    const url = new URL(value, location.href);
    url.searchParams.delete('section_id');
    url.hash = '';
    return url;
  }
  function getPage(value) {
    const url = cleanURL(value);
    const key = url.href;
    if (cache.has(key)) return cache.get(key);
    const endpoint = new URL(key);
    endpoint.searchParams.set('section_id', sectionId);
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    const promise = fetch(endpoint.href, {signal: controller.signal, credentials: 'same-origin'})
      .then(response => {
        if (!response.ok) throw new Error('Collection request failed');
        return response.text();
      })
      .then(html => {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const result = parsed.getElementById(section.id);
        if (!result || !result.querySelector('.collBoxProducts')) throw new Error('Missing products');
        return result;
      })
      .catch(error => { cache.delete(key); throw error; })
      .finally(() => clearTimeout(timeout));
    cache.set(key, promise);
    if (cache.size > 4) cache.delete(cache.keys().next().value);
    return promise;
  }
  function prefetchNext() {
    if (navigator.connection && (navigator.connection.saveData || /(^|-)2g$/.test(navigator.connection.effectiveType))) return;
    const next = section.querySelector('#collPagination a[title="Next"], #collPagination a[title="NEXT"]') ||
      Array.from(section.querySelectorAll('#collPagination a')).find(link => /next/i.test(link.textContent + ' ' + link.title));
    if (next) getPage(next.href).catch(() => {});
  }
  function schedulePrefetch() {
    if ('requestIdleCallback' in window) requestIdleCallback(prefetchNext, {timeout: 1500});
    else setTimeout(prefetchNext, 700);
  }
  async function navigate(value, push = true) {
    const url = cleanURL(value);
    const token = ++sequence;
    busy = true;
    section.setAttribute('aria-busy', 'true');
    status.textContent = 'Loading products…';
    try {
      const result = await getPage(url.href);
      if (token !== sequence) return;
      for (const selector of ['.collBoxSort', '.collBoxProducts', '#collPagination']) {
        const old = section.querySelector(selector);
        const fresh = result.querySelector(selector);
        if (old && fresh) old.replaceWith(document.importNode(fresh, true));
        else if (old) old.remove();
        else if (fresh) section.append(document.importNode(fresh, true));
      }
      if (push) history.pushState({peteCollection: true}, '', url.href);
      if (window.Shopify) Shopify.queryParams = Object.fromEntries(url.searchParams);
      const page = Number(url.searchParams.get('page') || 1);
      const baseTitle = document.title.replace(/\s*[–—-]\s*Page\s+\d+.*$/, '');
      document.title = page > 1 ? baseTitle + ' – Page ' + page : baseTitle;
      status.textContent = section.querySelector('.collProductCount')?.textContent.trim() || 'Products updated.';
      for (const callback of [window.ajaxFilterAddToCart, window.bingo?.wishlist, window.bingo?.quickview]) {
        if (typeof callback === 'function') { try { callback(); } catch (_) {} }
      }
      const anchor = section.querySelector('.collBoxSort');
      if (anchor && anchor.getBoundingClientRect().top < 0) anchor.scrollIntoView({block: 'start'});
      section.querySelector('.collBoxSort')?.setAttribute('tabindex', '-1');
      section.querySelector('.collBoxSort')?.focus({preventScroll: true});
      schedulePrefetch();
    } catch (_) {
      if (token === sequence) location.assign(url.href);
    } finally {
      if (token === sequence) {
        busy = false;
        section.removeAttribute('aria-busy');
        const legacy = document.getElementById('loading');
        if (legacy) legacy.style.display = 'none';
      }
    }
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('#collPagination a');
    if (!link || !section.contains(link) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    navigate(url.href);
  }, true);
  document.addEventListener('change', event => {
    if (event.target.id !== 'SortBy') return;
    event.stopImmediatePropagation();
    const url = cleanURL(location.href);
    url.searchParams.set('sort_by', event.target.value);
    url.searchParams.delete('page');
    navigate(url.href);
  }, true);
  window.addEventListener('popstate', () => navigate(location.href, false));
  for (const eventName of ['pointerover', 'focusin']) document.addEventListener(eventName, event => {
    const link = event.target.closest('#collPagination a');
    if (link && !busy) getPage(link.href).catch(() => {});
  }, {passive: true});
  schedulePrefetch();
})();
